import React from "react";

function Mainmenu() {
  return (
    <>
      <div className="mein-menu">
        <nav className="navbar navbar-expand-lg navbar-dark ">
          <div className="container">
            <a className="navbar-brand" href="#">
              <img src="images/logo.png" className="logo" alt="logo" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" aria-current="page" href="#home">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#about">
                    About
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#how-to-donate">
                    How to Donate
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link button" href="#donation">
                    {" "}
                    <i className="far fa-heart " />
                    <p className="text">
                      {" "}
                      <span>make your</span> donation
                    </p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Mainmenu;
